import { styleConstants, themeConstants } from '@paywithextend/components'
import { grey200, grey450 } from 'ext-ui/style/colors'
import { font_size_2xl, font_size_4xl, font_size_lg, font_size_md } from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`

.CancelSubscription-popup {
  display: flex;
  width: 700px;
  max-width: 700px;
  height: 630px;
  padding: 60px;
  flex-direction: column;
  align-items: flex-start;
  flex-shrink: 0;
}


.CancelSubscription-list-image {
  width: 101.85px;
  height: 93.203px;
  transform: rotate(-20deg);
  flex-shrink: 0;
  position: absolute;
  top: -10px;
  right: -32px;
  }

.CancelSubscription-container {
  display: flex;
  flex-direction: column;
  gap: 40px;
  align-self: stretch;
}

.CancelSubscription-header {
  font-size: ${font_size_4xl};
  color: ${themeConstants.colors.font_primary};
  font-family: ${styleConstants.fontFamilies.medium};
}

.CancelSubscription-text {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  align-self: stretch;
}

.CancelSubscription-button-container {
  display: flex;
  align-items: center;
  gap: 24px;
  align-self: stretch;
}

.CancelSubscription-feature-list-container {
  display: flex;
  width: 580px;
  padding: 20px;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  border-radius: 8px;
  border: 1px solid ${grey450};
  background: ${grey200};
}

.CancelSubscription-feature-list-header {
  font-size: ${font_size_2xl};
  color: ${themeConstants.colors.font_primary};
  font-family: ${styleConstants.fontFamilies.medium};
}

.CancelSubscription-feature-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-self: stretch;
}


.PricingCard-checklist-item-text {
  font-size: ${font_size_lg};
  line-height: 20px;
}

.LinkText {
  font-size: ${font_size_md};
  color: ${themeConstants.colors.cta};
  font-family: ${styleConstants.fontFamilies.medium};
}

.CancelSubscription-feature-list-content {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.CancelSubscription-submission-instructions {
  font-size: ${font_size_lg};
  color: ${themeConstants.colors.font_primary};
  font-family: ${styleConstants.fontFamilies.medium};
}

.CancelSubscription-submission-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.CancelSubscription-red-downgrade-text {
  font-size: ${font_size_lg};
  color: ${styleConstants.colors.red_dark};
  font-family: ${styleConstants.fontFamilies.medium};
}
`
